import { render } from "./productConfigurationSummary.vue?vue&type=template&id=4da321a0&scoped=true&ts=true"
import script from "./productConfigurationSummary.vue?vue&type=script&lang=ts"
export * from "./productConfigurationSummary.vue?vue&type=script&lang=ts"

import "./productConfigurationSummary.vue?vue&type=style&index=0&id=4da321a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da321a0"]])

export default __exports__